import React, { Component } from 'react';

import {Snippet, Highlight} from 'react-instantsearch/dom';

export class Result extends Component {
  render() {
    const { hit } = this.props;

    return (
      <div className="hit">
        <div className="image">
          <img src={hit.image} />
        </div>
        <div className="content">
          <h3>
            <a href={window.location.origin+hit.url}>
              <Highlight attributeName="title" hit={hit} />
            </a>
          </h3>
          <div className="content">
            <Snippet attributeName="content" hit={hit} />
            <div className="url">
              {window.location.origin}{hit.url}
            </div>
          </div>
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/result.js